import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, inject, TasksStore } from 'Mri.Web.Common';
import * as React from 'react';
import { UsersStore } from './UsersStore';

export interface IUserManageCardProps {
    readonly user: Mri.Web.Portal.Controllers.Account.UserModel;
}

@autoinject
@observer
export class UserManageCard extends React.Component<IUserManageCardProps> {
    public render() {
        return (
            <div className="card h-100">
                <div className="card-header bg-btn-primary">Manage</div>

                <div className="card-body p-0 pb-5">
                    <ul className="list-group list-group-flush">
                        <li className="list-group-item justify-content-between flex-items-center">
                            <div className="d-inline-block">Send Reset Password</div>

                            <a onClick={this.sendResetPassword} className="btn btn-primary my-1">
                                {this.sendingReset ? 'Sending...' : 'Send'}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }

    @bind
    @action
    private async sendResetPassword(event: React.MouseEvent<HTMLAnchorElement>) {
        this.sendingReset = true;
        const task = this.tasksStore.startSessionTask(`Send Reset Password Link`);

        try {
            await this.usersStore.sendResetPasswordAsync(this.props.user);
            task.complete();
        } catch (e: any) {
            task.error(e);
        } finally {
            this.sendingReset = false;
        }
    }

    @observable
    private sendingReset = false;
    @inject
    private usersStore!: UsersStore;
    @inject
    private tasksStore!: TasksStore;
}
